import { Box, Typography, Container, Divider } from "@mui/material";
import { Helmet } from "react-helmet-async";

function TermsOfService() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Helmet>
        <title>Terms of Use — Loops</title>
        <meta name="description" content="Read the Terms of Use for Loops, Malaysia's food deal discovery platform." />
        <link rel="canonical" href="https://loopsfood.com/terms" />
      </Helmet>
      <Typography
        variant="h3"
        sx={{ fontWeight: 500, mb: 2, textAlign: "center" }}
      >
        Terms of Use (Malaysia-compliant)
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: "#6b7280", mb: 6, textAlign: "center" }}
      >
        Last updated: October 7, 2025
      </Typography>

      <Divider sx={{ mb: 6 }} />

      <Box
        sx={{
          "& h4": { fontWeight: 500, mt: 4, mb: 2 },
          "& p": { mb: 2, lineHeight: 1.7 },
        }}
      >
        <Typography variant="h4">1. Introduction</Typography>
        <Typography variant="body1">
          These Terms of Use ("Terms") govern your access to and use of the
          Loops website, mobile site, and related services ("Loops," "we,"
          "our," or "us"). By using Loops, you agree to comply with and be bound
          by these Terms. If you do not agree, please do not use our platform.
        </Typography>

        <Typography variant="h4">2. Nature of Service</Typography>
        <Typography variant="body1">
          Loops provides a digital platform that aggregates and displays
          publicly available restaurant promotions, lunch deals, and offers in
          Malaysia. We are not the creator, owner, or distributor of the deals
          listed. Information is collected from public sources and presented for
          convenience only.
        </Typography>

        <Typography variant="h4">
          3. Intellectual Property and Trademarks
        </Typography>
        <Typography variant="body1">
          All logos, brand names, and trademarks shown on Loops are the property
          of their respective owners. Their appearance on our platform is for
          identification purposes only and does not imply endorsement or
          partnership.
        </Typography>
        <Typography variant="body1">
          The Loops name, logo, and proprietary features are protected under
          Malaysian copyright law (Copyright Act 1987) and Trademark Act 2019.
        </Typography>

        <Typography variant="h4">4. Accuracy of Information</Typography>
        <Typography variant="body1">
          We strive to ensure all information displayed on Loops is accurate and
          up-to-date. However, we do not guarantee the completeness,
          reliability, or availability of any content. Deals and promotions may
          change or expire without notice. Loops is not liable for any loss,
          damage, or inconvenience caused by reliance on such information.
        </Typography>

        <Typography variant="h4">
          5. Partnerships and Sponsored Listings
        </Typography>
        <Typography variant="body1">
          Loops may display paid listings, sponsored content, or promoted
          restaurants. Such listings will be clearly labeled as “Sponsored” or
          “Featured.” Any commercial relationship with restaurants or brands is
          governed by separate agreements and does not affect the accuracy or
          neutrality of general listings.
        </Typography>

        <Typography variant="h4">6. User Accounts and Subscriptions</Typography>
        <Typography variant="body1">
          Users may register for accounts or subscribe to paid plans for
          additional features. By subscribing, you agree to provide accurate
          information and authorize recurring payments (if applicable). Refund
          policies for paid plans will be stated clearly at the time of
          purchase.
        </Typography>

        <Typography variant="h4">7. Data Protection and Privacy</Typography>
        <Typography variant="body1">
          Loops complies with the Personal Data Protection Act 2010 (PDPA) of
          Malaysia. We process and store personal data only for purposes of user
          account management, analytics, and communication related to Loops
          services. For more details, refer to our Privacy Policy.
        </Typography>

        <Typography variant="h4">8. Prohibited Use</Typography>
        <Typography variant="body1">You agree not to:</Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <li>
            Scrape, reproduce, or distribute content from Loops without
            permission;
          </li>
          <li>Misrepresent affiliation with Loops;</li>
          <li>Upload malicious code, spam, or fraudulent content;</li>
          <li>
            Use Loops for unlawful purposes under the Communications and
            Multimedia Act 1998 or other Malaysian laws.
          </li>
        </Box>

        <Typography variant="h4">9. Limitation of Liability</Typography>
        <Typography variant="body1">
          Loops provides all information “as is” without warranty of any kind.
          We are not responsible for any direct, indirect, incidental, or
          consequential damages resulting from your use of or inability to use
          our platform.
        </Typography>

        <Typography variant="h4">10. Governing Law</Typography>
        <Typography variant="body1">
          These Terms shall be governed by and construed under the laws of
          Malaysia, and any disputes shall fall under the jurisdiction of the
          Courts of Malaysia.
        </Typography>
      </Box>
    </Container>
  );
}

export default TermsOfService;
